import React, {useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {useSelector} from 'react-redux';
import selectors from 'src/modules/ubicacion/ubicacionSelectors';
import UbicacionService from 'src/modules/ubicacion/ubicacionService';
import AutocompleteInMemoryFormItem from 'src/view/shared/form/items/AutocompleteInMemoryFormItem';
import UbicacionFormModal from 'src/view/ubicacion/form/UbicacionFormModal';

function UbicacionAutocompleteFormItem(props) {
  const {setValue, getValues} = useFormContext();

  const [modalVisible, setModalVisible] = useState(false);

  const hasPermissionToCreate = useSelector(selectors.selectPermissionToCreate);

  const doCloseModal = () => {
    setModalVisible(false);
  };

  const doOpenModal = () => {
    setModalVisible(true);
  };

  const doCreateSuccess = (record) => {
    const {name, mode} = props;

    if (mode && mode === 'multiple') {
      setValue(name, [...(getValues()[name] || []), record]);
    } else {
      setValue(name, record);
    }

    doCloseModal();
  };

  const fetchFn = (value, limit) => {
    if (props.filter) {
      //console.log('%c⧭', 'color: #00bf00', {filter: props.filter});
      return UbicacionService.listAutocomplete({value, filter: props.filter}, limit, {...props.filter});
    } else {
      return UbicacionService.listAutocomplete(value, limit);
    }
  };

  const mapper = {
    toAutocomplete(originalValue) {
      if (!originalValue) {
        return null;
      }

      const value = originalValue.id;
      let label = originalValue.label;

      if (originalValue.nombre) {
        label = originalValue.nombre;
      }

      return {
        key: value,
        value,
        label,
      };
    },

    toValue(originalValue) {
      if (!originalValue) {
        return null;
      }

      return {
        id: originalValue.value,
        label: originalValue.label,
      };
    },
  };

  return (
    <>
      <AutocompleteInMemoryFormItem
        {...props}
        entity="ubicacion"
        fetchFn={fetchFn}
        noLink
        mapper={mapper}
        onOpenModal={doOpenModal}
        hasPermissionToCreate={hasPermissionToCreate}
      />

      {modalVisible && <UbicacionFormModal minimalForm={props.minimalForm} onClose={doCloseModal} onSuccess={doCreateSuccess} />}
    </>
  );
}

export default UbicacionAutocompleteFormItem;
